<div class="chart-container">
  <figure>
      <h4>{{ idChart[0].title }}</h4>
      <canvas [id]="idChart[0].id"></canvas>
  </figure>
</div>